import { Select } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { supportedLngs } from "../../../@resource-interfaces/i18nModuleAugment"

export const LanguageSelect = React.forwardRef(LanguageSelectComponent)

function LanguageSelectComponent() {
  const { i18n } = useTranslation()

  return (
    <Select
      size="sm"
      px="sm"
      value={i18n.language}
      onChange={(val) => val && i18n.changeLanguage(val)}
      data={supportedLngs.map((language: string) => ({
        value: language,
        label: language.slice(0, 1).toLocaleUpperCase() + language.slice(1),
      }))}
    />
  )
}
